<template>
  <v-text-field
    class="search-bar"
    prepend-inner-icon="search"
    :label="label"
    rounded
    outlined
    single-line
    dense
    hide-details="auto"
    :error="!!error"
    :error-messages="error"
    :value="value"
    @input="onInput"
  >
    <template v-if="hasText" #append>
      <div>
        <v-progress-circular
          v-if="loading"
          class="mr-5"
          color="primary"
          indeterminate
          width="3"
          size="25"
        />
        <span
          v-else-if="hasResultCount"
          class="mr-5 grey--text text--darken-1"
        >
          {{ resultCount }} result{{ resultCount > 1 ? 's' : '' }}
        </span>
        <v-btn v-if="hasText" icon small @click="$emit('input', '')">
          <v-icon>highlight_off</v-icon>
        </v-btn>
      </div>
    </template>
  </v-text-field>
</template>
<script>
export default {
  name: 'SearchBar',
  props: {
    value: {
      type: String,
      default: null,
    },
    resultCount: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    debounce: {
      type: Number,
      default: 1000,
    },
    label: {
      type: String,
      default: 'Search',
    },
    error: {
      type: String,
      default: null,
    },
  },
  data: () => ({ debounceTimeout: null }),
  computed: {
    hasResults() {
      return (this.resultCount || 0) > 0;
    },
    hasResultCount() {
      return this.resultCount !== null;
    },
    hasText() {
      return this.value != null && this.value.trim().length > 0;
    },
  },
  destroyed() {
    clearTimeout(this.debounceTimeout);
  },
  methods: {
    onInput(input) {
      clearTimeout(this.debounceTimeout);
      if (input.trim().length > 0) {
        this.debounceTimeout = setTimeout(
          () => this.$emit('input', input),
          this.debounce
        );
      } else {
        // Skip debounce if clearing search box.
        this.$emit('input', input);
      }
    },
  },
};
</script>

<style>
/** Reduce padding from the left and right sides of the input */
.search-bar .v-input__control .v-input__slot {
  padding-right: 10px !important;
  padding-left: 10px !important;
}
/** Modify margin and padding of the append slot to better fit the clear button */
.search-bar .v-input__control .v-input__slot .v-input__append-inner {
  margin-top: 6px !important;
  margin-left: 10px;
  padding: 0 !important;
}
</style>
